<template>
    <div class="cooperation">
       <div class="header" :style="{background: 'url('+url+'/assets/AboutMustang/about-banner.png) no-repeat'}"></div>
       <div class="box">
          <div class="content">
            <p class="position">您所在的位置：首页 > 关于野马</p>
            <div class="main">
                <p class="title1">公司简介</p>         
                <p class="title2">江苏野马软件科技有限公司（简称 “野马软件”）是一家专门致力于高新技术项目研发的公司，以专业、快捷、高效、灵活为特色。公司于2015年5月在江苏徐州成立，注册资本为1000万元人民币。以诚信、创新、卓越、专注为服务宗旨。公司业务主要为物联网方向，业务线包括：“智慧安防"、"智慧公安"、"智慧园区"三大核心业务线。</p>
                <p class="title2">野马软件作为国内智能物联领域的探路者和践行者，被认定为双软企业以及高新企业，2016年获得江苏省大学生优秀创业项目同时获得江苏省专项资金扶持。2017年5月曾获得微软全球大学生竞赛二等奖。经过数年技术积累和沉淀，野马软件在智慧安防、移动警务、智慧园区、大数据分析、人脸识别等领域积累了丰富的经验。</p>
                <p class="title2">目前，公司产品已为500多家企业、多地政府、公安部门提供了产品和技术咨询与服务，并为数十家大型集团企业提供了产品整体解决方案。除此之外，我们还可以为客户量身定制、策划、设计、开发服务；以时尚、科技的设计和专业技术水准帮助不同的客户实现物联网/互联网的蓝图。</p>
                <div class="list">
                    <div class="img" v-for="(item, index) in list" :key="index">
                        <img :src="item">
                    </div>
                </div>
            </div>
        </div>
       </div>
        <div class="development">
            <p class="title">发展历程</p>
            <div class="list" v-for="(item, index) in AboutMustangArr" :key="index">
                <div class="left bounceInLeft" :style='"animation-delay:"+index*2+"s"'>
                  <img :src="item.img">
                </div>
                <div class="center" :style="{background: 'url('+url+'/assets/AboutMustang/line.png) no-repeat'}">
                    <img class="circle" :src="url + '/assets/AboutMustang/circle.png'">
                </div>
                <div class="right bounceInRight" :style='"animation-delay:"+index*2+"s"'>
                    <p class="text">{{item.title}}</p>
                    <p class="text">{{item.title2}}</p>
                    <p class="infor">{{item.content}}</p>
                </div>
            </div>
        </div>
        <div class="box">
          <div class="content">
            <div class="main">
                <p class="title3">资质荣誉</p> 
                <div class="list2">
                    <swiper class="swiper swiperList" ref="swiper"  :options="swiperOption" >
                        <swiper-slide v-for="(item, index) in list2" :key="index">
                            <div class="img">
                                <img :src="item">
                            </div>
                        </swiper-slide>
                        <div class="swiper-button-prev" slot="button-prev"></div>
                        <div class="swiper-button-next" slot="button-next"></div>
                    </swiper>
                </div>
            </div>
        </div>
       </div>
        <foot></foot>
    </div>
</template>
<script>
import defaultSettings from '@/defaultSettings'
const img1 = defaultSettings.url + '/assets/AboutMustang/1.jpg'
const img2 = defaultSettings.url + '/assets/AboutMustang/2.jpg'
const img3 = defaultSettings.url + '/assets/AboutMustang/4.jpg'
const img4 = defaultSettings.url + '/assets/AboutMustang/3.jpg'
const lc1 =  defaultSettings.url + '/assets/other/lc1.jpg'
const lc2 =  defaultSettings.url + '/assets/other/lc2.jpg'
const lc3 =  defaultSettings.url + '/assets/other/lc3.jpg'
const lc4 =  defaultSettings.url + '/assets/other/lc4.jpg'
const lc5 =  defaultSettings.url + '/assets/other/lc5.jpg'
const lc6 =  defaultSettings.url + '/assets/other/lc6.jpg'
const ry1 =  defaultSettings.url + '/assets/other/ry1.png'
const ry2 =  defaultSettings.url + '/assets/other/ry2.png'
const ry3 =  defaultSettings.url + '/assets/other/ry3.png'
const ry4 =  defaultSettings.url + '/assets/other/ry4.png'
const ry5 =  defaultSettings.url + '/assets/other/ry5.png'
const ry6 =  defaultSettings.url + '/assets/other/ry6.png'
const ry7 =  defaultSettings.url + '/assets/other/ry7.png'
const ry8 =  defaultSettings.url + '/assets/other/ry8.png'
const ry9 =  defaultSettings.url + '/assets/other/ry9.png'
const ry10 = defaultSettings.url + '/assets/other/ry10.png'
const ry11 = defaultSettings.url + '/assets/other/ry11.png'
const ry12 = defaultSettings.url +'/assets/other/ry12.png'
const ry13 = defaultSettings.url + '/assets/other/ry13.png'
const ry14 =  defaultSettings.url + '/assets/other/ry14.png'
const ry15 =  defaultSettings.url + '/assets/other/ry15.png'
const ry16 =  defaultSettings.url + '/assets/other/ry16.png'

import foot from '../components/foot'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
export default {
  data() {
    return {
        url: defaultSettings.url,
        swiperOption: {
          loop: true,
            // 自动轮播
          autoplay: {
            delay: 3000,
            stopOnLastSlide: true,
            /* 触摸滑动后是否继续轮播 */
            disableOnInteraction: true,
          },
          slidesPerView: 6,
          spaceBetween: 16,
          direction: 'horizontal',
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          // on: {
          //   resize: () => {
          //     this.$refs.swiper.$swiper.changeDirection(
          //       window.innerWidth <= 960
          //         ? 'vertical'
          //         : 'horizontal'
          //     )
          //   }
          // }
        },
        list: [
            img1, img2, img3, img4
        ],
        list2: [
          ry1, ry2, ry3, ry4,ry5, ry6, ry7, ry8, ry9, ry10, ry11, ry12, ry13, ry14, ry15, ry16
        ],
        AboutMustangArr:[
            {
                id: 1,
                title: '2015年5月',
                title2: '江苏野马软件科技有限公司成立',
                content: '公司位于江苏省徐州市CBD金融中心，注册资金1000万元整，拥有500㎡的办公场地',
                img: lc1
            },
            {
                id: 2,
                title: '2016年10月',
                img: lc2,
                title2: '月牛到家APP首次上线',
                content: '在2016年企业组比赛中，公司团队研发的月牛到家产品获得专项资金扶持同时获得江苏省大学生优秀创业项目'
            },
            {
                id: 3,
                title: '2017年5月',
                img: lc3,
                title2: '开辟公司第一条“智慧安防”产品线',
                content: '在2017年8月，智慧安防APP首次上线，V1.0版本首次首次应用于江苏多个智慧工地安防场景、维护中，取得了江苏省信息化办公室的高度认可和赞同后续2.0、3.0版本持续更新。同年获得微软全球大学生竞赛二等奖'
            },
            {
                id: 4,
                title: '2018年12月',
                img: lc4,
                title2: '被认定双软企业',
                content: '“双软企业”是指软件产品评估和软件企业评估，获得软件企业和软件产品的认证资格'
            },
            {
                id: 5,
                title: '2019年10月',
                img: lc5,
                title2: '开辟公司第二条“智慧公安”产品线',
                content: '在2019年12月，智慧公安V1.0首次服务于江苏盐城公安部门，2020年年初又相继推出移动警务和警网通产品，已在江苏多地公安部门投入使用'
            },
            {
                id: 6,
                title: '2020年5月',
                img: lc6,
                title2: '开辟公司第三条“智慧园区”产品线',
                content: '在2020年5月，智慧园区V1.0首次服务于江苏省徐州市淮海经济现代化园区中，产品功能覆盖了园区人员管理、入驻企业招聘、人员安全等进行全方位赋能，通过大数据分析可视化平台综合管理和预警'
            },
        ]
    }
  },
  components: {
    Swiper,
    SwiperSlide,
    foot
  },
  mounted() {
    window.scrollTo({ left: 0, top: 0 })
  },
  methods: {
  }
}
</script>
<style lang="less" scoped>
.swiper-slide{
    width:200px!important;
    margin:0 15px!important;
}
// .swiper-button-next {
//     right: 20px;
//     transform: rotate(90deg);
// }

// .swiper-button-prev {
//     left: 20px;
//     transform: rotate(90deg);
// }
@keyframes bounceInRight {
  from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
  }

  from {
    opacity: 0;
    transform: translate3d(3000px, 0, 0);
  }

  60% {
    opacity: 1;
    transform: translate3d(-25px, 0, 0);
  }

  75% {
    transform: translate3d(10px, 0, 0);
  }

  90% {
    transform: translate3d(-5px, 0, 0);
  }

  to {
    transform: none;
  }
}

.bounceInRight {
  animation-name: bounceInRight;
  animation-duration: 2s;
  animation-fill-mode: both;
}

@keyframes bounceInLeft {
  from, 60%, 75%, 90%, to {
    animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);
  }

  0% {
    opacity: 0;
    transform: translate3d(-3000px, 0, 0);
  }

  60% {
    opacity: 1;
    transform: translate3d(25px, 0, 0);
  }

  75% {
    transform: translate3d(-10px, 0, 0);
  }

  90% {
    transform: translate3d(5px, 0, 0);
  }

  to {
    transform: none;
  }
}

.bounceInLeft {
  animation-name: bounceInLeft;
  animation-duration: 2s;
  animation-fill-mode: both;
}
.cooperation{
    background: #F6F6F6;
    // height:100vh;
    height: 100%;
    position: relative;
    overflow: auto;
    padding-top:90px;
      .header {
        background-size: 100% 100%!important;
        position: relative;
        height:450px;
    }
    .box{
        background: #fff;
    }
    .content{
        width:1200px;
        margin:0 auto;
        .position{
            padding-top:25px;
            color:#999999;
            font-size:14px;
            margin-bottom:50px;
        }
        .main{
            text-align: center;
            // margin-bottom:500px;
            .title1{
                font-size:30px;
                color:#333;
                margin-bottom:36px;
            }
            .title2{
                color:#666;
                font-size:16px;
                text-align: left;
                margin-bottom:55px;
            }
            .title3{
                font-size:30px;
                color:#333;
                padding-top:40px;
                margin-bottom:36px;
            }
            .list{
                padding-bottom:70px;
                .img{
                    width:280px;
                    height:360px;
                    margin:11px 10px;
                    display: inline-block;
                    img{
                        width:100%;
                        transition: all 0.6s;
                    }
                    img:hover{
                        transition: all 0.6s;
                        transform: scale(1.08);
                    }
                }
            }
            .list2{
               padding-bottom:70px;
               width:1100px;
               margin:0 auto;
                .img{
                    width:207px;
                    box-shadow: 0px 2px 10px 0px rgba(38, 38, 38, 0.1);
                    height:280px;
                    margin:8px 8px;
                    padding:10px;
                    display: inline-block;
                    background: #fff;
                    img{
                        width:100%;
                    }
                } 
            }
        }
    }
    .development{
        width:850px;
        margin:50px auto 40px;
        text-align: center;
        .title{
            margin-bottom:30px;
            font-size:30px;
            color:#333;
            margin-bottom:100px;
        }
        .list{
            position: relative;
            display: flex;
             margin-top:50px;
            .left{
                width:376px;
                height:144px;
                img{
                   width:376px;
                height:144px;
                }
                // background: #0A4A98;
            }
            .center{
                margin:0 50px;
                height:250px;
                position: relative;
                width:1px;
                background-size: 100% 100%!important;
                margin-top:-60px;
                text-align: center;
                .circle{
                    position: absolute;
                    top:60px;
                    left:-13px;
                    width:28px;
                    height:28px;
                }
            }
            .right{
                text-align: left;
                width:480px;
                .text{
                    font-size: 20px;
                    font-weight: bold;
                    color: #333333;
                }
                .infor{
                    margin-top:35px;
                    font-size: 16px;
                    color: #333;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/view/AboutMustang.vue